
import $ from 'jQuery';
import './machine_app_green_checkbox.css';

export function greenCheckbox(isChecked = false){
  const lCheckbox = $('<span>')
    .addClass('machine_app_green_checkbox');

  const lCheckIcon = $('<i>').addClass('far fa-check');

  const check = () => {
    lCheckbox.addClass('checked');
    lCheckbox.append(lCheckIcon);
  };

  const uncheck = () => {
    lCheckbox.removeClass('checked');
    lCheckbox.remove(lCheckIcon);
  };

  if(isChecked) check();

  return {
    widget: lCheckbox,
    controls: {
      check: check,
      uncheck: uncheck
    }
  };
}